<script>
export default {
	props: {
		order: Object,
		payment: Object,
	},
	computed: {
		plan() {
			return this.payment.data || {}
		},
	},
}
</script>

<template>
	<div class="pa-1">
		<div>{{ plan.title }}</div>
		<div>{{ plan.description }}</div>
		<div class="d-flex align-center">
			<span>{{ plan.qty }} cuotas de</span>
			<PriceText
				:amount="plan.installmentsAmount"
				:currency="order.currency.sign"
				:sup-decimals="false"
				class="ml-1"
			/>
		</div>
	</div>
</template>

<style></style>

